import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import CTA from '../CTA';
const Button = forwardRef((_a, ref) => {
    var { selected } = _a, props = __rest(_a, ["selected"]);
    return (React.createElement(CTA, Object.assign({ primary: true, Tag: "button" }, props, { ref: ref })));
});
export default Button;
//# sourceMappingURL=Button.js.map